import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dca04b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M128 544h768a32 32 0 1 0 0-64H128a32 32 0 0 0 0 64z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m160 96.064 192 .192a32 32 0 0 1 0 64l-192-.192V352a32 32 0 0 1-64 0V96h64v.064zm0 831.872V928H96V672a32 32 0 1 1 64 0v191.936l192-.192a32 32 0 1 1 0 64l-192 .192zM864 96.064V96h64v256a32 32 0 1 1-64 0V160.064l-192 .192a32 32 0 1 1 0-64l192-.192zm0 831.872-192-.192a32 32 0 0 1 0-64l192 .192V672a32 32 0 1 1 64 0v256h-64v-.064z"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { ref, watch } from 'vue'

interface Props {
  title?: string
  modelValue: boolean
  width?: string
  center?: boolean
  top?: string
  beforeClose?: () => void
  closeOnClickModal?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'dialog',
  props: {
    title: null,
    modelValue: { type: Boolean },
    width: null,
    center: { type: Boolean },
    top: null,
    beforeClose: null,
    closeOnClickModal: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', val: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title?: string, modelValue: boolean, width?: string, center?: boolean, top?: string, beforeClose?: () => void, closeOnClickModal: boolean }



const visible = ref(false)
const fullscreen = ref(false)



watch(
  () => props.modelValue,
  val => {
    visible.value = val
  },
  {
    immediate: true
  }
)

watch(
  () => visible.value,
  val => {
    emit('update:modelValue', val)
  }
)

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    "close-on-click-modal": __props.closeOnClickModal,
    title: __props.title,
    width: __props.width,
    top: __props.top,
    fullscreen: fullscreen.value,
    center: __props.center,
    "before-close": __props.beforeClose,
    draggable: ""
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "full-screen",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (fullscreen.value = !fullscreen.value))
      }, [
        (fullscreen.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
          : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    (_ctx.$slots.footer)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer")
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "close-on-click-modal", "title", "width", "top", "fullscreen", "center", "before-close"]))
}
}

})